import Vue from 'vue'
import Vuex from 'vuex'
import ApiCaller from "../utils/apicaller";
import constant from '../utils/constant'
import types from "./types";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    allTasks: [],
    pendingTasks: [],
    updateUserInfo: []
  },
  mutations: {
    [types.UPDATE_USER_INFO]: (state, payload) => {
      state.updateUserInfo = payload;
    },
    [types.ALL_TASKS]: (state, payload) => {
      state.allTasks = payload;
    },
    [types.PENDING_TASKS]: (state, payload) => {
      state.pendingTasks = payload;
    },
    [types.GET_USER_INFO]: (state, payload) => {
      state.userInfo = payload;
    },
  },
  getters: {
    userInfo: state => {
      return state.userInfo;
    },
    allTasks: state => {
      return state.allTasks;
    },
    pendingTasks: state => {
      return state.pendingTasks;
    },
    updateUserInfo: state => {
      return state.updateUserInfo;
    },
  },
  actions: {
    getUserInfo({ commit }, { type, payload }) {
      return ApiCaller(constant.USERINFO_URL, "user/" + payload, "get");
    },
    getNews({ commit }, { type, payload }) {
      console.log('==', payload)
      return ApiCaller(constant.BASE_API_URL, `tasks/news_status/${payload.activeState}/?limit=${payload.limit}`, "get");
    }, 
  },
  modules: {
  }
})
